import React from 'react'
import { Cars } from '../../component/Cars'

export default function CarsPage() {
  return (
    <Cars />
  )
}
